<template>
  <v-combobox
    v-bind="{...defaults, ...$attrs}"
    class="ol-combobox"
    v-on="$listeners"
  >
    <template
      v-for="(_, slot) of $scopedSlots"
      #[slot]="scope"
    >
      <slot
        :name="slot"
        v-bind="scope"
      />
    </template>
    <slot />
  </v-combobox>
</template>

<script>
export default {
  name: 'OlCombobox',
  inheritAttrs: false,
  beforeCreate() {
    this.defaults = {
      filled: true,
      'background-color': 'white'
    }
  }
}
</script>
